import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section className="section contact-section">
      <div className="contact-content">
        <p className="contact-text">
          Researchers and builders interested in early access to Kolosis may reach out at{' '}
          <a href="mailto:research@kolosian.ai" className="contact-link">research@kolosian.com

          </a>
        </p>
      </div>
    </section>);

};

export default Contact;